import React, { useState } from 'react';
import { Container } from 'reactstrap';
import PageBreadcrumb from '../../Components/Common/PageBreadcrumb';
import '../TenderOpening/components/TenderOpening.css';
import OfferTable from './components/OfferTable';

// This page lists Product Hydro offers only (ProcurementTypeHeader = 1).
const PROCUREMENT_TYPE_HEADER = '1';

const OfferView = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  document.title = 'List Offer';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <div className='to-page email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
            <div className='email-content minimal-border'>
              <div className='p-4'>
                <div className='to-hero mb-4'>
                  <PageBreadcrumb
                    fallback={{ label: 'Offer', to: '/apps-offer/view' }}
                  />

                  <div className='d-flex align-items-center gap-3 flex-wrap'>
                    <span className='to-hero-icon'>
                      <i className='ri-hand-coin-line' aria-hidden='true' />
                    </span>
                    <div className='flex-grow-1'>
                      <h4 className='to-hero-title'>Offer</h4>
                      <p className='to-hero-subtitle'>
                        Review your tender offers, follow the offering window
                        and continue drafting or submitting your proposal.
                      </p>
                    </div>
                    <button
                      type='button'
                      className='to-hero-btn'
                      onClick={handleRefresh}
                    >
                      <i className='ri-refresh-line' aria-hidden='true' />
                      Refresh
                    </button>
                  </div>
                </div>

                <OfferTable
                  procurementTypeHeader={PROCUREMENT_TYPE_HEADER}
                  refreshTrigger={refreshTrigger}
                  exportName='Product Hydro'
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OfferView;
